import useSimpleList from "core/features/shared/useSimpleList";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

function SelectAmbienteVotacao({ ...rest }: SelectBaseAntdProps) {
  const { isLoading, data } = useSimpleList("v1/ambiente-votacao");

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      {...rest}
      showSearch
      allowClear
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectAmbienteVotacao;
